import { IMiningPlanOptions as IMiningPlanOptions } from "../../getMinerList";
import { UserMeta } from "@services/editUser";

export interface NotificationsEmails {
  email: string;
  is_verified: boolean;
}

export interface PrivateSettingI {
  is_private: boolean;
  value: string;
}

export interface ITag {
  name: string;
  id: number | string;
}

export enum UserRole {
  Admin = "a",
  Moder = "m",
  User = "u",
  Tech = "t",
  God = "g",
  SuperAdmin = "s",
  Unknown = "__role_unknown__",
};

export interface IBaseAccount {
  Id: number;
  uuid: string;
  name?: string;
  Name?: string;
  email: PrivateSettingI;
  avatar: string;
  telegram: PrivateSettingI;
  telegram_uid?: string;
  telegram_bot_link: string; //link to telegram bot registration
  telegram_bot_qrcode: string; // png-image as base64
  about: string;
  notification_emails: NotificationsEmails[];
  created: number; // unix
  updated: number; // unix
  owner?: boolean;
  role: UserRole;
  summary_email: boolean;
  summary_telegram: boolean;
  twofa: boolean;
  tags?: ITag[];
  meta?: UserMeta;
}

export interface IAccount extends IBaseAccount {
  is_admin?: boolean;
  controller_id?: string;
  m_online: number;
  m_offline: number;
  m_low: number;
}

export interface TokenData {
  Token: string;
  TokenExpiresAt: number; // server time, exm: 1662381864,
  TokenLifeTime: number; // in seconds: 172800 = 48 * 60 * 60 (h*m*s)
}

export interface IPlanContract {
  readonly id: number;
  //DomainId int64  `json:"-"` // ignored
  readonly name: string;
  readonly password: string;
  readonly meta: string;
}

export interface AccountRecord extends TokenData {
  account: IAccount;
  //for admin
  plans?: IMiningPlanOptions[];
  types?: string[];
  contracts?: IPlanContract[];
}
/*
export interface AccountResponse extends ServerResponse {
  Record: AccountRecord;
}
*/
